module.exports = [
	{
		id: 'pricenegotiation',
		title: "Price Negotiation",
		description: "Client (often procurement or economic buyer) challenges the price, asking for a lower rate or referencing competitors’ pricing. This is a common, evergreen negotiation scenario across service lines."
	},
	{
		id: 'costjustification',
		title: "Technology Cost Justification",
		description: "Client questions why technology or AI does not make the service cheaper, or why they should pay for internal technology investments. The scenario focuses on explaining the value and cost of technology to the client."
	},
	{
		id: 'changeorder',
		title: "Change Orders/Scope Management",
		description: "Scenario involves negotiating change orders or additional billing for extra work performed, highlighting the need to address scope changes and payment for additional services, relevant for both junior and senior staff."
	}
];
